$(function () {
  $(document).on('ready', function (e) {
    $('#composite_modifier_user_id_search').removeAttr('data-behavior-refresh-form');
  });
});
